export const getDistanceForPerfectProjection = function (fov = 60, height = window.innerHeight) {
  // const fov = this.fov
  // const height = window.innerHeight
  const vFov = fov * (Math.PI / 180)
  const z = height / (2 * Math.tan(vFov / 2))
  return z
}


export const randSign = function () {
  return Math.random() < 0.5 ? -1 : 1
}



// WEBPACK FOOTER //
// ./src/components/game/utils.js